import styled, { keyframes } from 'styled-components';
import { Form } from '@unform/web';

const appearFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(-500px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

const appearBackground = keyframes`
  from {
    background-color: transparent;
  }
  to {
    background-color: rgba(0, 0, 0, 0.5);
  }
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
	top: 0;
  z-index: 6;
  animation: ${appearBackground} 0.5s;
  transition: ${appearBackground} 0.5s;

  .active {
    opacity: 1;
    top: 30%;
    visibility: visible;
    animation: ${appearFromTop} 0.4s;

    @media (max-width: 650px) {
      animation: ${appearFromTop} 0.4s;
    }
  }

  div::-webkit-scrollbar {
    display: none; /* Might be enough */
    background: transparent;
    visibility: hidden;
    width: 0px;
  }
  div {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  top: -500px;
  position: fixed;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  opacity: 0;
  border-radius: 5px;
  padding: 20px 40px;
  visibility: hidden;
  transition: all 0.5s ease-out;

  h1 {
    font-weight: 500;
  }
  h2 {
    margin-left: 10px;
    color: #455a64;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 0;
  width: 100%;
  margin-bottom: 10px;

  h1 {
    font-size: 20px;
    font-weight: 500;
  }

  button {
    color: var(--azul-razio);
    margin-left: 15px;

    svg {
      font-size: 20px;
      margin-right: 5px;
    }
  }
`;

export const FormView = styled(Form)`
  display: flex;
  flex-direction: column;

	-ms-overflow-style: 'none';
	overflow: -moz-scrollbars-none;
	scrollbar-width: 'none';

  .input-content {
    display: flex;
    margin-bottom: 20px;

    .input {
      display: flex;
      align-items: center;

      span {
        font-size: 16px;
        font-weight: 500;
        margin-right: 10px;
      }
    }

    .input:last-child {
      span {
        margin-left: 10px;
      }
    }
  }

  .buttons {
    display: flex;

    button:first-child {
      margin-right: 10px;
    }
  }
`;
